import { Link } from 'react-router-dom';
import { Circle } from 'lucide-react';
import type { Academy } from '@court-sync/shared';
import { Button } from '@/components/ui';
import { buildAcademyPath } from '@/lib/academyPaths';

export interface StarterMemberAuthNotFoundProps {
  academy?: Academy | null;
  academySlug?: string | null;
}

/**
 * Shown when a visitor hits student/guardian auth or self-service booking routes
 * on a Starter academy (member portals are not available).
 */
export function StarterMemberAuthNotFound({
  academy,
  academySlug,
}: StarterMemberAuthNotFoundProps) {
  const browsePath =
    academy != null
      ? buildAcademyPath(academy, '/lessons')
      : academySlug
        ? `/academy/${encodeURIComponent(academySlug)}/lessons`
        : '/';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
      <Circle className="mb-4 h-16 w-16 text-muted-foreground" aria-hidden />
      <h1 className="mb-2 text-2xl font-bold text-foreground">Page not found</h1>
      <p className="mb-6 max-w-md text-center text-muted-foreground">
        {academy?.name ? (
          <>
            <span className="font-medium text-foreground">{academy.name}</span> uses the Starter plan.
            Student and guardian accounts are not available — families can browse lessons and submit a
            booking request instead.
          </>
        ) : (
          'Student and guardian sign-in is not available for this academy.'
        )}
      </p>
      <Button asChild variant="outline">
        <Link to={browsePath}>Browse lessons</Link>
      </Button>
    </div>
  );
}
